// extracted by mini-css-extract-plugin
export default {"active":"Edit_active__hymn5","inActive":"Edit_inActive__GdiV3","box":"Edit_box__LcSou","iconWrapper":"Edit_iconWrapper__ErAkZ","icon":"Edit_icon__hjGNQ","label":"Edit_label__7nOXf"};